module.exports = __webpack_public_path__ + "img/minipack-badge.af2bcb58.svg";